/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { EnqueteEditPageContentUserVariableDefinitionFragmentDoc, EnqueteEditPageContentEnquetePayloadFragmentDoc } from './EnqueteEditPageContent.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type EnqueteEditPageQueryVariables = Exact<{
  guid: string | number;
}>;


export type EnqueteEditPageQuery = { enquete: { enquete: { guid: string, title: string, answerEnqueteLiffAppPageUrl: string | null, answerCount: number, questions: Array<{ guid: string, questionText: string, isAnswerRequired: boolean, userVariableDefinition: { __typename: 'UserVariableDefinition', guid: string, name: string, value:
            | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ __typename: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> }
            | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ __typename: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> }
            | { __typename: 'UserVariableDefinitionValueString', void: any }
            | { __typename: 'UserVariableDefinitionValueText', void: any }
           } }>, answeredChatMessage: { body: string, selections: Array<string> | null } | null } }, userVariableDefinitions: Array<{ guid: string, name: string, value:
      | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
      | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
      | { __typename: 'UserVariableDefinitionValueString', void: any }
      | { __typename: 'UserVariableDefinitionValueText', void: any }
     }> };


export const EnqueteEditPageDocument = gql`
    query EnqueteEditPage($guid: ID!) {
  enquete(guid: $guid) {
    ...EnqueteEditPageContentEnquetePayload
  }
  userVariableDefinitions {
    ...EnqueteEditPageContentUserVariableDefinition
  }
}
    ${EnqueteEditPageContentEnquetePayloadFragmentDoc}
${EnqueteEditPageContentUserVariableDefinitionFragmentDoc}`;

/**
 * __useEnqueteEditPageQuery__
 *
 * To run a query within a Vue component, call `useEnqueteEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnqueteEditPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEnqueteEditPageQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useEnqueteEditPageQuery(variables: EnqueteEditPageQueryVariables | VueCompositionApi.Ref<EnqueteEditPageQueryVariables> | ReactiveFunction<EnqueteEditPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EnqueteEditPageQuery, EnqueteEditPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EnqueteEditPageQuery, EnqueteEditPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EnqueteEditPageQuery, EnqueteEditPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EnqueteEditPageQuery, EnqueteEditPageQueryVariables>(EnqueteEditPageDocument, variables, options);
}
export function useEnqueteEditPageLazyQuery(variables?: EnqueteEditPageQueryVariables | VueCompositionApi.Ref<EnqueteEditPageQueryVariables> | ReactiveFunction<EnqueteEditPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<EnqueteEditPageQuery, EnqueteEditPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EnqueteEditPageQuery, EnqueteEditPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EnqueteEditPageQuery, EnqueteEditPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EnqueteEditPageQuery, EnqueteEditPageQueryVariables>(EnqueteEditPageDocument, variables, options);
}
export type EnqueteEditPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EnqueteEditPageQuery, EnqueteEditPageQueryVariables>;